import {
  GET_LEAD_PRICES,
  GET_LEAD_PRICES_SUCCESS,
  GET_LEAD_PRICES_ERROR,

} from "./actionTypes"

export const getLeadPrices = payload => {
  return {
    type: GET_LEAD_PRICES,
    payload: payload,
  }
}

export const getLeadPricesSuccess = lead_prices => {
  return {
    type: GET_LEAD_PRICES_SUCCESS,
    payload: lead_prices,
  }
}

export const getLeadPricesError = error => {
  return {
    type: GET_LEAD_PRICES_ERROR,
    payload: error,
  }
}
